import styled from "styled-components";
import photo1 from "assets/images/algas-01.jpg";
import photo2 from "assets/images/algas-02.jpg";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  background-color: white;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    flex-shrink: unset;
    flex-grow: unset;
    height: 100%;
  }
`;

export const Content = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 88px;
  position: relative;

  @media screen and (max-width: 1010px) {
    height: auto;
    width: 100vw;
    padding: 57px 40px;
  }
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 602px;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: unset;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 279px);
  grid-column-gap: 88px;

  @media screen and (max-width: 1010px) {
    grid-template-columns: auto;
    grid-column-gap: unset;
    grid-row-gap: 24px;
  }
`;

export const Title = styled.h3`
  font-family: ${fonts.BentonSansMedium};
  font-size: 33px;
  line-height: 61px;
  text-transform: uppercase;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const TitleWide = styled.h2`
  font-family: ${fonts.BentonSansWideMedium};
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 72px;
  color: black;

  @media screen and (max-width: 1010px) {
    margin-top: 32px;
    margin-bottom: 32px;
  }
`;

export const Text = styled.article`
  width: 100%;
  font-size: 15px;
  line-height: 22px;

  p {
    margin-bottom: 24px;

    a {
      text-decoration: underline;
      color: black;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Photo1Wrapper = styled.div`
  display: flex;
  height: 100%;
  position: relative;

  @media screen and (max-width: 1010px) {
    padding: 0 40px;
  }
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  object-fit: contain;
  height: 100%;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo2Wrapper = styled.div`
  position: relative;
  align-self: center;
  margin-right: 720px;

  @media screen and (max-width: 1010px) {
    padding: 0 40px;
    margin-right: 0;
    margin-bottom: 500px;
  }
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const CreditPhoto1 = styled.span`
  font-size: 15px;
  line-height: 22px;
  color: black;
  display: block;
  position: absolute;
  top: 24px;
  left: -32px;
  writing-mode: vertical-rl;
  transform: rotate(180deg);

  @media screen and (max-width: 1010px) {
    writing-mode: unset;
    transform: rotate(0deg);
    top: unset;
    left: 40px;
    bottom: -32px;
    font-size: 12px;
  }
`;

export const CreditPhoto2 = styled.span`
  font-size: 15px;
  line-height: 22px;
  color: black;
  display: block;
  position: absolute;
  top: 32px;
  left: 32px;

  @media screen and (max-width: 1010px) {
    top: unset;
    left: 40px;
    bottom: -24px;
    font-size: 12px;
  }
`;
